/**
 * The app prompt shows at most once per visit (brief, TASK-1155): a tab's
 * `sessionStorage` lives exactly as long as the visit. Storage that throws
 * (Safari private mode, disabled site data) reads as "not shown yet" and
 * swallows the write — the page never breaks over it; the worst case is
 * the prompt on a later page of the same visit.
 */
const KEY = 'metro.appPrompt.shown'

export function promptAlreadyShown(storage: () => Storage = () => sessionStorage): boolean {
  try {
    return storage().getItem(KEY) === '1'
  } catch {
    return false
  }
}

export function markPromptShown(storage: () => Storage = () => sessionStorage): void {
  try {
    storage().setItem(KEY, '1')
  } catch {
    // Storage unavailable — see above.
  }
}
